import OrderItemPayment from './order_item_payment';

export default OrderItemPayment;
